import { IconCurrencyCircleDollar, IconGift, IconTruck } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  BuyAndWinBenefitVariant,
  GIFT_APPLICATION,
  ShippingApplyTo,
  type BuyAndWinFreeShipping,
  type BuyAndWinGift,
  type MaximumUnitPriceDiscount,
} from '../../../../../typings'
import { Options } from '../../../../BenefitMenu'
import { messages as benefitMessages } from './messages'

export const EMPTY_GIFT_BENEFIT: BuyAndWinGift = {
  type: BuyAndWinBenefitVariant.GIFT,
  items: [],
  maxQuantity: 1,
  application: GIFT_APPLICATION.PER_CART,
}

export const EMPTY_FREE_SHIPPING_BENEFIT: BuyAndWinFreeShipping = {
  type: BuyAndWinBenefitVariant.FREE_SHIPPING,
  applyTo: ShippingApplyTo.all,
}

export const EMPTY_MAX_UNIT_PRICE_BENEFIT: MaximumUnitPriceDiscount = {
  type: BuyAndWinBenefitVariant.MAXIMUM_UNIT_PRICE_DISCOUNT,
  price: 0,
}

export const EMPTY_BENEFIT_BY_TYPE = {
  [BuyAndWinBenefitVariant.GIFT]: EMPTY_GIFT_BENEFIT,
  [BuyAndWinBenefitVariant.FREE_SHIPPING]: EMPTY_FREE_SHIPPING_BENEFIT,
  [BuyAndWinBenefitVariant.MAXIMUM_UNIT_PRICE_DISCOUNT]:
    EMPTY_MAX_UNIT_PRICE_BENEFIT,
} as const

export const DEFAULT_BENEFIT = EMPTY_GIFT_BENEFIT

export const BENEFIT_OPTION_BY_TYPE = {
  [BuyAndWinBenefitVariant.FREE_SHIPPING]: {
    Icon: IconTruck,
    label: <FormattedMessage {...benefitMessages.freeShipping.label} />,
  },
  [BuyAndWinBenefitVariant.GIFT]: {
    Icon: IconGift,
    label: <FormattedMessage {...benefitMessages.gift.label} />,
  },
  [BuyAndWinBenefitVariant.MAXIMUM_UNIT_PRICE_DISCOUNT]: {
    Icon: IconCurrencyCircleDollar,
    label: <FormattedMessage {...benefitMessages.maxUnitPrice.label} />,
  },
}

export const BuyAndWinBenefitOptions: Options = Object.entries(
  BENEFIT_OPTION_BY_TYPE
).map(([name, rest]) => ({ name, ...rest }))
